export default __webpack_public_path__ + "static/media/pod-overview-chart.9287aac7.png";